import Notification from './Notification';
export default Notification;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rmc-notification/es/index.js
// module id = 460
// module chunks = 0